import React from 'react';

import { ValidationRule } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

interface IProps {
  htmlFor: string;
  disabled?: boolean;
  required?: string | ValidationRule<boolean>;
  children: string;
  customStyles?: string;
}

export const Label = ({
  htmlFor,
  disabled = false,
  required = false,
  children,
  customStyles = '',
  ...rest
}: IProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(`${disabled ? 'text-disabled' : 'text-abyss'} mb-1 text-sm`, customStyles)}
      {...rest}
    >
      {required ? (
        children
      ) : (
        <>
          {children}{' '}
          <span className={disabled ? 'text-disabled' : 'text-midnight'}>(optional)</span>
        </>
      )}
    </label>
  );
};
